import { getToken } from "firebase/messaging";
import { doc, setDoc } from "firebase/firestore";
import { db, auth } from "../Auth/firebase";
import { initializeMessaging } from "./messaging";

const vapidKey = process.env.REACT_APP_VAPID_KEY;

export const requestPermission = async (serviceWorkerRegistration, uid = null) => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      return null;
    }

    const messagingInstance = await initializeMessaging();
    if (!messagingInstance) {
      return null;
    }

    const getTokenOptions = { vapidKey };
    if (serviceWorkerRegistration) {
      getTokenOptions.serviceWorkerRegistration = serviceWorkerRegistration;
    }

    const token = await getToken(messagingInstance, getTokenOptions);

    const targetUid = uid || auth.currentUser?.uid;

    if (token && targetUid) {
      await setDoc(
        doc(db, "users", targetUid),
        {
          fcmToken: {
            web: token,
          },
          updatedAt: new Date(),
        },
        { merge: true }
      );
    }

    return token;
  } catch (error) {
    return null;
  }
};